import { render, staticRenderFns } from "./TheNFTManagerLayout.vue?vue&type=template&id=0f3fa1b8"
import script from "./TheNFTManagerLayout.vue?vue&type=script&lang=js"
export * from "./TheNFTManagerLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports